module.exports = __webpack_public_path__ + "img/email_unread.d6680e22.svg";